module.exports = __webpack_public_path__ + "static/img_2055-da709f7fefdafd65d750fe40593f5f47.webp";